<template>
    <v-container
        fluid
        fill-height
        class="transition-all"
        :style="{
                backgroundImage: `url(${this.urlAssets}${contextual_image})`,
                minHeight: `100vh`,
                backgroundAttachment: `fixed`,
                backgroundPosition: `center`,
                backgroundRepeat: `no-repeat`,
                backgroundSize: `cover`
        }"
    >
        <v-row class="ma-7 d-flex justify-center flex-column" v-if="evaluationId">
            <v-col>
                <v-row class="justify-center align-center flex-column flex-md-row">
                    <v-card
                        min-width="10vh"
                        class="ma-5 rounded-lg"
                        style="border: 3px solid #816ad6;"
                    >
                        <v-container fluid class="py-1">
                            <v-row align="center" style="position: relative;">
                                <v-img
                                    src="/img/user/points.svg"
                                    max-height="55px"
                                    max-width="55px"
                                    class="ml-1 align-center"
                                    style="z-index: 1; color: #816ad6;"
                                    >20</v-img>
                                <v-img
                                    src="/img/user/beecoin.svg"
                                    max-height="55px"
                                    max-width="55px"
                                    class="align-center"
                                    style="
                                        position: absolute;
                                        left: -20px;
                                        top: -10px;
                                        color: #df820d;
                                    "
                                    >20</v-img>
                                <v-card-title
                                    class="justify-end pa-0 px-2"
                                    :style="{
                                        color: '#816ad6',
                                        fontWeight: 'bold',
                                        fontSize: '16px'
                                        }
                                    "
                                >
                                    {{ $t('challenge.rewards') }}
                                </v-card-title>
                            </v-row>
                        </v-container>
                    </v-card>
                    <v-card
                        min-width="10vh"
                        class="ma-5 rounded-lg border-radius-3"
                        style="border: 3px solid #df820d;"
                    >
                        <v-container fluid class="py-1">
                            <v-row align="center" style="position: relative;">
                                <v-img
                                    src="/img/user/beecoin-3.svg"
                                    max-height="55px"
                                    max-width="55px"
                                    class="ml-1"
                                />
                                <v-card-title
                                    class="justify-end pa-0 px-1"
                                    :style="{
                                        color: '#df820d',
                                        fontWeight: 'bold',
                                        fontSize: '16px',
                                    }"
                                >
                                    {{ coins }} {{ $t('beeCoins') }}
                                </v-card-title>
                            </v-row>
                        </v-container>
                    </v-card>
                </v-row>
                <v-row class="position-relative">
                    <v-card
                        class="mx-auto border-radius-3 pa-7 position-relative opacity-95"
                        max-width="70%"
                        outlined
                        elevation="5"
                        id="main"
                        :style="`font-size:${
                            config ? config.fontSize : ''
                        }px !important;font-family:${mainFont}!important;`"
                    >
                        <v-row justify="center" align="center" class="position-relative">
                            <v-img
                                :src="readersSoundImageURL"
                                max-height="70px"
                                contain
                                class="main-sound-img cursor-pointer"
                                @click="playReading"
                            ></v-img>
                            <v-col cols="10">
                                <Highlightable
                                    :useHighlight="false"
                                    :useNotes="false"
                                    @dictionary="onDictionary"
                                    ref="highlightable"
                                >
                                    <v-card-text
                                        data-cy="mainContainer-title"
                                        class="justify-center text-h4 mb-10"
                                        style="color: #4a3216;"
                                    >
                                        {{ text_name }}
                                    </v-card-text>
                                    <div
                                        v-for="(page, index) in pages"
                                        :key="index"
                                        :style="{
                                    fontSize: `${config ? config.fontSize : ''}px !important`,
                                    fontFamily: `${mainFont}!important`,
                                    color: '#4a3216',
                                    lineHeight: '1.5',
                                    display: 'flex',
                                    justifyContent: 'center'
                                }"
                                    >
                                        <ChallengePage
                                            :texts="page"
                                            :page-number="index + 1"
                                            v-if="challengePage === index + 1"
                                            :active="challengePage === index + 1"
                                        />
                                    </div>
                                </Highlightable>
                            </v-col>
                        </v-row>
                        <audio id="audio_zen" v-show="false">
                            <source
                                v-for="(track, index) of global.ZEND_SOUNDS"
                                :key="index"
                                :data-track-number="index"
                                :src="`${global.ZEND_MUSIC_URI}${track}`"
                                type="audio/mpeg"
                            />
                        </audio>

                        <div class="w-100">
                            <ChallengeFooter
                                :current-page="challengePage"
                                :total-pages="pages.length"
                                :is-last-page="challengePage === pages.length"
                                @next="nextPage"
                                @back="previousPage"
                                @finish="showQuestion"
                            />
                        </div>
                    </v-card>
                    <UtilsPanel
                        class="position-fixed"
                        :style="{
                            top: '10vh',
                        }"
                    />
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import Highlightable from '@/components/reading/core/Highlightable.vue'
import global from '@/constants/GlobalConstant'
import ChallengePage from './ChallengePage.vue'
import ChallengeFooter from './ChallengeFooter.vue'
import Markjs from '../../../mixins/Markjs'
import UtilsPanel from './UtilsPanel.vue'
const PAGES_PARTS = 3

export default {
    components: {
        UtilsPanel,
        Highlightable,
        ChallengePage,
        ChallengeFooter,
    },
    data: () => ({
        selectedText: '',
        global,
        zenIndex: 0,
        urlAssets: process.env.VUE_APP_BEEREADERS_ASSETS_URL,
        loading:false,
        snackbar: false,
    }),
    methods: {
        ...mapActions('challenge', [
            'ShowQuestion',
            'setReadingTime',
            'setReReadingTime',
            'updateConfig',
            'increasePage',
            'decreasePage',
        ]),
        ...mapActions('bookReading', [
            'showDictionary',
            'setDictionaryMode',
            'setWord',
        ]),
        showQuestion() {
            this.ShowQuestion()
            if (this.stShowQuestions) {
                this.setReadingTime(new Date().getTime() - this.tiempoEmpleadoLectura)
                if (this.tiempoEmpleadoReLectura !== 0) {
                    this.setReReadingTime(new Date().getTime() - this.tiempoEmpleadoReLectura)
                }
            } else {
                this.setReadingTime(new Date().getTime() + this.tiempoEmpleadoLectura)
                if (this.tiempoEmpleadoReLectura !== 0) {
                    this.setReReadingTime(new Date().getTime() + this.tiempoEmpleadoReLectura)
                }
            }
        },
        nextPage() {
            if (this.challengePage < this.pages.length) this.increasePage()
        },
        previousPage() {
            if (this.challengePage > 1) this.decreasePage()
        },
        onDictionary(text) {
            const clean = text.replace(' ', ',')
            const arr = clean.split(',')
            this.resetVars()
            if (arr.length > 1 && arr[1]) {
                this.$modal.warning(this.$t('bookReading.warnDictionary'))
                return
            }
            this.setDictionaryMode('auto')
            this.setWord(arr[0])
            this.showDictionary()
        },
        resetVars() {
            this.selectedText = ''
            this.$refs.highlightable.resetVars()
        },
        playBackgroundMusic() {
            const audioZen = document.getElementById('audio_zen')
            const vm = this
            if (audioZen) {
                const songURL = audioZen.children[this.zenIndex].src

                audioZen.setAttribute('src', songURL)
                audioZen.onended = () => {
                    vm.zenIndex += 1
                    if (audioZen.children.length < vm.zenIndex) {
                        vm.zenIndex = 0
                    }
                    const nextSong = audioZen.children[this.zenIndex].src
                    audioZen.setAttribute('src', nextSong)
                    setTimeout(() => audioZen.play(), global.ZEND_PLAY_DELAY)
                }
                if (this.soundActive) setTimeout(() => audioZen.play(), global.ZEND_PLAY_DELAY)
                else this.pausePlayer(audioZen)

                this.updateConfig(this.user.id)
            }
        },
        pausePlayer(player) {
            player.pause()
        },
        setVolume(vol) {
            const audioZen = document.getElementById('audio_zen')
            if (audioZen) audioZen.volume = vol / 100
            this.updateConfig(this.user.id)
        },
        playReading() {
            this.readerSound = !this.readerSound;
            this.readCurrentText(false);
        },
    },
    computed: {
        ...mapState({
            user_loaded: (state) => state.userData.user_loaded,
            user_id: (state) => state.userData.user.id,
            user: (state) => state.userData.user,
            controlsTexts: (state) => state.challenge.controlsTexts,
            challengePage: (state) => state.challenge.challengePage,
            text_name: (state) => state.challenge.textName,
            evaluationId: (state) => state.challenge.evaluationId,
            challengeCategories: (state) => state.challenge.challengeCategories,
            coins: (state) => state.userData.coins,
            categories: (state) => state.categories,
            sound: (state) => state.challenge.config.soundVol,
            tiempoEmpleadoLectura: (state) => state.challenge.tiempoEmpleadoLectura,
            tiempoEmpleadoReLectura: (state) => state.challenge.tiempoEmpleadoReLectura,
            config: (state) => state.challenge.config,
            stShowQuestions: (state) => state.challenge.showQuestion,
            testId: (state) => state.challenge.testId,
        }),
        playSound() {
            return this.soundActive
        },
        volume() {
            return this.sound
        },
        contextual_image() {
            if (!this.challengeCategories || !this.challengeCategories.length) return 'default.jpg'

            const userBirthdate = this.$moment(this.user.birthDate, 'YYYY')
            const diff = this.$moment().diff(userBirthdate, 'years')
            const category = this.challengeCategories[
                Math.floor(Math.random() * this.challengeCategories.length)
            ]
            if (category) {
                const mainCategory = this.categories.find((el) => {
                    return el.id === category.lbMetaDataCategoryId
                })
                if (mainCategory) {
                    const image = mainCategory.categoryContextualImageDTOList.find(
                        (el) =>
                            diff >= el.bookCategorizationAgeRangeDTO.fromAge &&
                            diff <= el.bookCategorizationAgeRangeDTO.toAge
                    )

                    if (image) {
                        return `${image.resourceDir}.png`
                    }
                } else return 'default.jpg'
            }
            return 'default.jpg'
        },
        mainFont() {
            switch (this.config.typography) {
                case '0':
                    return "'Poppins', sans-serif"
                case '1':
                    return "'Roboto', sans-serif"
                case '2':
                    return "'Comic Sans MS', arial"
                case '3':
                    return "'Arial', fantasy"
                default:
                    return 'Arial'
            }
        },
        pages() {
            const { controlsTexts } = this
            return this.$utils.divideArrayInEqualsParts(controlsTexts, PAGES_PARTS)
        },
        readersSoundImageURL() {
            return this.isNarratorActive ? '/img/user/soundpauseicon.svg' : '/img/user/soundicon.svg'
        }
    },
    mounted() {
        if (this.playSound) {
            this.playBackgroundMusic()
        }
    },
    async beforeDestroy() {
        await this.removeChallengeAudio()
    },
    mixins: [Markjs]
}
</script>

<style scoped>
.nuevo {
    border-width: 1px;
    border-color: blue;
}
.main-sound-img {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1
}
</style>
